import React from "react";
import Sidebar from "../../../Components/Sidebar/Sidebar";
import { employeeSideBarItems } from "./Routes";

const Navbar = () => {
  return <Sidebar sideBarItems={employeeSideBarItems} />;
};

export default Navbar;
